import { render, staticRenderFns } from "./StockTypeList.vue?vue&type=template&id=c07bf3ce&scoped=true"
import script from "./StockTypeList.vue?vue&type=script&lang=js"
export * from "./StockTypeList.vue?vue&type=script&lang=js"
import style0 from "./StockTypeList.vue?vue&type=style&index=0&id=c07bf3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07bf3ce",
  null
  
)

export default component.exports